// client/src/store/slices/SuperAdminSlice.js

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isAuthenticated: false,
    superAdmin: null,
};

const superAdminSlice = createSlice({
    name: 'superAdmin',
    initialState,
    reducers: {
        setSuperAdmin(state, action) {
            state.isAuthenticated = true;
            state.superAdmin = action.payload.superAdmin;
        },
        clearSuperAdmin(state) {
            state.isAuthenticated = false;
            state.superAdmin = null;
        },
        updateSuperAdmin(state, action) {
            state.superAdmin = { ...state.superAdmin, ...action.payload };
        }
    },
});

export const { setSuperAdmin, clearSuperAdmin, updateSuperAdmin } = superAdminSlice.actions;
export default superAdminSlice.reducer;
